module.exports = __webpack_public_path__ + "img/buy-icon3.6d29c40.png";